import React from 'react';
import ReactDOM from 'react-dom';

// import DevTools from 'mobx-react-devtools';

import { observer } from 'mobx-react';

import '../sass/main.sass';
import App from './App';

console.log(document.getElementById('app'));
ReactDOM.render(<App />, document.getElementById('app'));

// Hot Module Replacement
if (module.hot) {
  module.hot.accept();
}
